module.exports = __webpack_public_path__ + "static/media/Tarots_01_All-13.29906278.svg";